// extracted by mini-css-extract-plugin
module.exports = {"btn":"MoreButton_btn__1-_X_"};